module.exports = __webpack_public_path__ + "static/media/icon-facebook.b2836405.svg";